import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	body: {
		padding: `${spacing.lg}px ${spacing.lg}px`,
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
		maxWidth: 560,
		minWidth: 480,
	},
	detailsList: {
		display: 'grid',
		gridTemplateColumns: 'auto 1fr',
		columnGap: `${spacing.md}px`,
		rowGap: `${spacing.xs}px`,
		margin: `${spacing.sm}px 0 ${spacing.md}px`,
		fontSize: typography.fontSizes.sm,
	},
	errorText: {
		color: colors.danger.dark,
	},
	footer: {
		alignItems: 'center',
		borderTop: `1px solid ${colors.border.light}`,
		display: 'flex',
		gap: spacing.sm,
		justifyContent: 'flex-end',
		padding: `${spacing.md}px ${spacing.lg}px`,
	},
	header: {
		alignItems: 'center',
		borderBottom: `1px solid ${colors.border.light}`,
		display: 'flex',
		padding: `${spacing.lg}px ${spacing.lg}px`,
	},
	helperText: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		margin: 0,
	},
	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
		listStyle: 'none',
		margin: 0,
		padding: 0,
	},
	loading: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		padding: spacing.xxl,
	},
	muted: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},
	section: {
		marginTop: spacing.md,
	},
	sectionHeader: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		margin: `0 0 ${spacing.sm}px`,
	},
	statusBadgeDisabled: {
		background: colors.background.dark,
		borderRadius: 12,
		color: colors.text.main,
		display: 'inline-block',
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		padding: `${spacing.xs}px ${spacing.sm}px`,
		textTransform: 'uppercase',
	},
	statusBadgeError: {
		background: colors.danger.light,
		borderRadius: 12,
		color: colors.danger.dark,
		display: 'inline-block',
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		padding: `${spacing.xs}px ${spacing.sm}px`,
		textTransform: 'uppercase',
	},
	statusBadgeEnabled: {
		background: colors.success.light,
		borderRadius: 12,
		color: colors.success.dark,
		display: 'inline-block',
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		padding: `${spacing.xs}px ${spacing.sm}px`,
		textTransform: 'uppercase',
	},
	statusRow: {
		alignItems: 'center',
		display: 'flex',
		gap: spacing.sm,
	},
	title: {
		color: colors.text.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
	},
});
